/**
 * useBackendConfig — React-hook som returnerar runtime-config från backend.
 *
 * Returnerar:
 *   { config, loading, error }
 *
 * config är null tills första fetchConfig() löser. Cachas globalt via
 * src/api/config.js så flera komponenter inte dubbel-fetchar.
 *
 * Används av Login.js för att veta om SSO-knappen ska visas.
 * Andra komponenter kan ropa fetchConfig() direkt.
 */

import { useEffect, useState } from 'react';
import { fetchConfig, getConfigSync } from './config';

export function useBackendConfig() {
  const [config, setConfig] = useState(getConfigSync());
  const [loading, setLoading] = useState(!config);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    // Om konfig redan är cachad, inget att göra
    if (getConfigSync()) {
      setConfig(getConfigSync());
      setLoading(false);
      return;
    }
    fetchConfig()
      .then((cfg) => {
        if (!cancelled) {
          setConfig(cfg);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err);
          setLoading(false);
        }
      });
    return () => { cancelled = true; };
  }, []);

  return { config, loading, error };
}
